module.exports = __webpack_public_path__ + "static/scale-model-of-fac-water-tower-in-fresno-california-83b1180486a798f791616e21dd5f8d7e.png";